import React from 'react'
import { Progress } from 'antd';

const Progressbar = (props) => {
  return (
    <div> <Progress type="circle" percent={Math.round(props.progress)} size={props.size || 90} strokeColor="#2e1a47" /></div>
  )
}

export default Progressbar